import ResultsService from '../../services/ResultsService'
import types from './types'

const service = new ResultsService()

export function listenForResults(pollId) {
	return (dispatch, getState) => {
		if (pollId in getState().results) return

		service.listen(pollId, (results) => {
			dispatch({
				type: types.RESULTS_UPDATED,
				payload: { pollId, results },
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/results.js